import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const quickBookAPI = createApi({
    reducerPath: "quickBookAPI",
    baseQuery,
    endpoints: (builder) => ({
        checkRTDb: builder.mutation({
            query: () => {
                return {
                    url: "admin/quickbook/auth/login",
                    method: "GET"
                };
            },
            transformResponse: (response) => response,
        })
    })
});

export const { 
    useCheckRTDbMutation
} = quickBookAPI;

export default quickBookAPI;